import {Invitation} from '../../types/invitation';

export enum InvitationActionTypes {
    SetInvitation = 'INVITATION/setInvitation'
}

export type InvitationAction =
    | {type: InvitationActionTypes.SetInvitation, invitation?: Invitation}
